import React from 'react'
import PropTypes from 'prop-types'
import { CAUSAL_TOOLTIP } from '../../config/settings/constant'
import { ExclamationIcon, IconButton, PopoverTypography, PopoverWithOutPadding } from './AbilityStatusSection.styles'

/**
 * The button with icon and popover component
 **/
const ButtonWithPopover = ({ padding }) => {
  return (
    <PopoverWithOutPadding
      anchor={
        <IconButton>
          <ExclamationIcon padding={padding} />
        </IconButton>
      }
      originX="center"
    >
      <PopoverTypography padding="20px" variant="body1">
        {CAUSAL_TOOLTIP}
      </PopoverTypography>
    </PopoverWithOutPadding>
  )
}

ButtonWithPopover.defaultProps = {
  padding: '0 0 5px'
}
ButtonWithPopover.propTypes = {
  padding: PropTypes.string
}

export default ButtonWithPopover
